<div class="container container-padding">
    <h1 class="page-header">{{'LOGIN.APP_NAME' | translate}}</h1>

    <div class="separator double"></div>

    <app-alert *ngIf="flag?.active === false">
        {{ 'SCHEDULE.SALE_IS_NOT_ACTIVE' | translate }}
    </app-alert>

    <div class="tiles">
        <a class="tile"
           *ngIf="!readonly"
           [routerLink]="['/new-offer']">
            <div class="tile-content">
                <i class="icon-new"></i>
                <div class="tile-desc">
                    {{'DASHBOARD.NEW_OFFER' | translate}}
                </div>
                <div class="tile-sub-desc">
                    {{'DASHBOARD.NEW_OFFER_SUB' | translate}}
                </div>
            </div>
        </a>

        <a class="tile"
           *ngIf="user?.frontierAccess"
           [routerLink]="['/new-frontier']">
            <div class="tile-content">
                <i class="icon-new"></i>
                <div class="tile-desc">
                    {{'DASHBOARD.NEW_OFFER' | translate}}
                </div>
                <div class="tile-sub-desc">
                    {{'DASHBOARD.NEW_FRONTIER_SUB' | translate}}
                </div>
            </div>

        </a>

        <a class="tile"
           [routerLink]="['/registry']">
            <div class="tile-content">
                <i class="icon-card-index"></i>

                <div class="tile-desc">
                    {{'DASHBOARD.REGISTRY' | translate}}
                </div>
                <div class="tile-sub-desc">
                    {{'DASHBOARD.REGISTRY_SUB' | translate}}
                </div>
            </div>
        </a>

        <a class="tile"
           *ngIf="user?.timetableAccess"
           [routerLink]="['/timetable']">
            <div class="tile-content">
                <i class="icon-settings"></i>

                <div class="tile-desc">
                    {{'TIMETABLE.TITLE' | translate}}
                </div>
                <div class="tile-sub-desc">
                    {{'TIMETABLE.SUBTITLE' | translate}}
                </div>
            </div>
        </a>
    </div>
</div>

